import DefaultLayout from '@/layouts/LayoutDefault';
import { loggedIn, notLoggedIn } from '../middlewares';

import devices from './devices/routes';
import datasets from './datasets/routes';
import collections from './collections/routes';
import apps from './apps/routes';
import medias from './medias/routes';
import schemas from './schemas/routes';
import schedules from './schedules/routes';
import users from './users/routes';
import notifications from './notifications/routes';
import datatypes from './datatypes/routes';
import logout from './logout';

export default [
  {
    path: '',
    redirect: { name: 'devices' }
  },
  {
    path: '/',
    component: DefaultLayout,
    meta: {
      middleware: [loggedIn]
    },
    children: [
      {
        path: 'devices',
        component: () => import('./devices'),
        children: devices,
        middleware: [loggedIn]
      },
      {
        path: 'datasets',
        component: () => import('./datasets'),
        children: datasets,
        middleware: [loggedIn]
      },
      {
        path: 'collections',
        component: () => import('./collections'),
        children: collections,
        middleware: [loggedIn]
      },
      {
        path: 'apps',
        component: () => import('./apps'),
        children: apps,
        middleware: [loggedIn]
      },
      {
        path: 'medias',
        meta: {
          middleware: [loggedIn]
        },
        component: () => import('./medias'),
        children: medias
      },
      {
        path: 'datatypes',
        meta: {
          middleware: [loggedIn]
        },
        component: () => import('./datatypes'),
        children: datatypes
      },
      {
        path: 'schemas',
        meta: {
          middleware: [loggedIn]
        },
        component: () => import('./schemas'),
        children: schemas
      },
      {
        path: 'schedules',
        meta: {
          middleware: [loggedIn]
        },
        component: () => import('./schedules'),
        children: schedules
      },
      {
        path: 'notifications',
        children: notifications,
        component: () =>
          import(/* webpackChunkName: "notifications" */ './notifications'),
        meta: {
          middleware: [loggedIn]
        }
      },
      {
        path: 'users',
        meta: {
          middleware: [loggedIn]
        },
        component: () => import('./users'),
        children: users
      }
    ]
  },
  {
    path: '/login',
    name: 'login',
    component: () =>
      import(/* webpackChunkName: "main" */ './auth/AuthFormLogin.vue'),
    meta: {
      middleware: [notLoggedIn]
    }
  },
  {
    path: '/from-app',
    name: 'from-app',
    component: () =>
      import(/* webpackChunkName: "auth" */ './auth/LoginFromApp.vue'),
    meta: {
      middleware: [notLoggedIn]
    }
  },
  {
    path: '/logout',
    name: 'logout',
    component: logout
  },
  {
    path: '/forgot',
    name: 'forgot',
    component: () =>
      import(/* webpackChunkName: "main" */ './auth/AuthFormForgot.vue'),
    meta: {
      middleware: [notLoggedIn]
    }
  },
  {
    path: '/enrollment',
    name: 'enrollment',
    component: () =>
      import(/* webpackChunkName: "main" */ './auth/AuthFormEnrollment.vue'),
    meta: {
      middleware: [notLoggedIn]
    }
  },
  {
    path: '/password',
    name: 'password',
    component: () =>
      import(/* webpackChunkName: "main" */ './auth/AuthFormNewPassword.vue'),
    meta: {
      middleware: [notLoggedIn]
    }
  },
  {
    path: '*',
    redirect: {
      name: 'devices'
    },
    meta: {
      middleware: [loggedIn]
    }
  }
];
